import { get } from 'lodash';
import { Role } from '../interfaces/role';
import { removeEmpty } from '../../utils';
import { instance } from './instance';

const getError = (err: Error | unknown): string => {
  return get(err, 'response.data.error', get(err, 'message', err)) as string;
};

export const getAllRoles = async () => {
  try {
    const resp = await instance.get(`/role`, { data: {} });
    return get(resp, 'data.roles', []);
  } catch (_err) {
    const err = getError(_err) as string;
    console.warn(err);
    throw new Error(err);
  }
};

export const createRole = async (role: Role) => {
  try {
    const resp = await instance.post('/role', {
      role: removeEmpty(role),
    });
    return get(resp, 'data.role');
  } catch (err: any) {
    console.warn(err);
    throw new Error(err);
  }
};

export const signUpUser = async (estring: string, password: string) => {
  try {
    const resp = await instance.post('/role/user/confirm', {
      estring,
      password,
    });
    return get(resp, 'data.user');
  } catch (_err) {
    const err = getError(_err) as string;
    console.warn(err);
    throw new Error(err);
  }
};

export const changeUserPassword = async (
  email: string,
  code: string,
  password: string
) => {
  try {
    const resp = await instance.post(`/role/user/changeuserpassword`, {
      email,
      // AER-1654: send the raw emailed pin; the backend verifies it against the
      // server-side pin store (data-table `pins#<email>`) before resetting /
      // self-healing the account.
      code,
      password,
    });
    return get(resp, 'data.data', []);
  } catch (_err) {
    const err = getError(_err) as string;
    throw new Error(err);
  }
};

export const getIntegrations = async () => {
  const resp = await instance.get('/role/integrations');
  return get(resp, 'data.data', []);
};
